import { reportCrash, } from './report-crash';
const createReactErrorHandler = (app, kind) => {
    return (error, errorInfo) => {
        try {
            console.error(`React ${kind} error:`, error, errorInfo);
        }
        catch (_a) {
        }
        reportCrash({
            app,
            error,
            kind,
            componentStack: errorInfo.componentStack,
        });
    };
};
export const createReactRootErrorHandlers = (app) => ({
    onCaughtError: createReactErrorHandler(app, 'react_caught'),
    onUncaughtError: createReactErrorHandler(app, 'react_uncaught'),
    onRecoverableError: createReactErrorHandler(app, 'react_recoverable'),
});
